import { render, staticRenderFns } from "./UserMescanMetabolismCell.vue?vue&type=template&id=4ccf5800&scoped=true"
import script from "./UserMescanMetabolismCell.vue?vue&type=script&lang=js"
export * from "./UserMescanMetabolismCell.vue?vue&type=script&lang=js"
import style0 from "./UserMescanMetabolismCell.vue?vue&type=style&index=0&id=4ccf5800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccf5800",
  null
  
)

export default component.exports